"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _commonReact = require("@devsta/common-react");

var _ManageCredits = _interopRequireDefault(require("../components/ManageCredits"));

var _api = require("../api");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ManageCreditsContainer(_ref) {
  var organisationId = _ref.organisationId,
      creditBalance = _ref.creditBalance,
      creditType = _ref.creditType,
      teams = _ref.teams,
      onUpdateCreditType = _ref.onUpdateCreditType,
      onUpdateOrgBalance = _ref.onUpdateOrgBalance,
      onUpdateTeams = _ref.onUpdateTeams,
      orgPackage = _ref.orgPackage;
  return _react.default.createElement(_commonReact.RequestProvider, {
    requests: {
      changeCreditType: (0, _api.changeCreditTypeMutation)(organisationId),
      getMonthlySubmissions: (0, _api.getMonthlySubmissionsQuery)(organisationId)
    }
  }, function (_ref2) {
    var changeCreditType = _ref2.changeCreditType,
        getMonthlySubmissions = _ref2.getMonthlySubmissions;
    return _react.default.createElement(_commonReact.CreditsConsumer, null, function (_ref3) {
      var onCreditsUpdated = _ref3.actions.onCreditsUpdated;
      return _react.default.createElement(_ManageCredits.default, {
        organisationId: organisationId,
        creditBalance: creditBalance,
        creditType: creditType,
        changeCreditType: changeCreditType,
        teams: teams,
        onUpdateCreditType: onUpdateCreditType,
        onUpdateOrgBalance: onUpdateOrgBalance,
        onUpdateTeams: onUpdateTeams,
        orgPackage: orgPackage,
        getMonthlySubmissions: getMonthlySubmissions,
        onCreditsUpdated: onCreditsUpdated
      });
    });
  });
}

var _default = ManageCreditsContainer;
exports.default = _default;